import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 2rem;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 9;
  transform: translateY(9rem) translateX(${({ dir }) => (dir === 'rtl' ? '1rem' : '-1rem')});
  display: none;

  @media (max-width: 991.98px) {
    transform: translateY(23.5rem) translateX(${({ dir }) => (dir === 'rtl' ? '1rem' : '-1rem')});
  }

  @media (max-width: 767.98px) {
    transform: translateY(21.5rem) translateX(${({ dir }) => (dir === 'rtl' ? '1rem' : '-1rem')});
  }
`;

export const Title = styled.span`
  font-family: ${({ dir }) =>
    dir === 'rtl' ? 'GEAwtarDWTCMedium,serif' : 'LibreBaskervilleRegular '};
  color: #4a4a4a;
  text-align: center;
  margin: 1.5rem 0;
  font-size: 1.25rem;

  @media (min-width: 48rem) {
    font-size: 1.625rem;
  }

  @media (min-width: 75rem) {
    font-size: 1.875rem;
  }
`;
